import vehicleImage from '@/assets/404.png'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ErrorPage } from './ErrorPage.tsx'

export function NotFoundComponent() {
  const { t } = useTranslation('_routes')

  return (
    <ErrorPage
      errorCode={404}
      title={t('components.ErrorPages.notFound.title')}
      subtitle={t('components.ErrorPages.notFound.subtitle')}
    >
      <Box
        component="img"
        src={vehicleImage}
        alt="404 Vehicle"
        sx={{
          width: '600px',
          height: 'auto',
          maxWidth: '100%',
          zIndex: 1,
          mb: 4
        }}
      />
    </ErrorPage>
  )
}
